import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import Button from '@/components/primitives/Button.jsx';
import Input from '@/components/primitives/Input.jsx';
import loadSignedInContext from '@/redux/actions/sessionActions/loadSignedInContext.js';
import { signInWithPassword } from '@/redux/requests/sessionRequests.js';
import AuthLayout from '../components/AuthLayout.jsx';
import AuthNotice from '../components/AuthNotice.jsx';
import describeAuthFailure from '../lib/describeAuthFailure.js';

/** Email and password sign-in. After it, the route gate returns the person to where they were going. */
const SignInPage = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const next = searchParams.get('next');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);
    const res = await signInWithPassword({ email: email.trim(), password });

    if (res?.success === false) {
      setIsSubmitting(false);
      setError(describeAuthFailure(res));
      return;
    }

    dispatch(loadSignedInContext());
  };

  return (
    <AuthLayout
      title="Sign in to Pieve"
      footer={
        <>
          New to Pieve?{' '}
          <Link className="auth-link" to={next ? `/sign-up?next=${encodeURIComponent(next)}` : '/sign-up'}>
            Create an account
          </Link>
        </>
      }>
      <form className="auth-form" onSubmit={handleSubmit} noValidate>
        <AuthNotice>{error}</AuthNotice>
        <Input label="Email" type="email" name="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} required />
        <Input label="Password" type="password" name="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required />
        <div className="auth-form__row">
          <Link className="auth-link" to="/forgot-password">
            Forgot your password?
          </Link>
        </div>
        <div className="auth-form__submit">
          <Button type="submit" variant="primary" size="lg" loading={isSubmitting} disabled={!email.trim() || !password}>
            Sign in
          </Button>
        </div>
      </form>
    </AuthLayout>
  );
};

export default SignInPage;
